var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732863740959,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 43736,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M848.512 981.312H219.904a133.696 133.696 0 0 1-134.592-132.992V175.68c0-73.6 60.16-132.992 134.592-132.992h628.608A47.36 47.36 0 0 1 896 89.6v844.8a46.4 46.4 0 0 1-47.488 46.912z m-628.608-844.8a38.976 38.976 0 0 0-39.552 39.104v672.704c0 21.952 17.408 39.168 39.552 39.168h582.656V136.512H219.904z",
    fill: "#000000",
    "p-id": 43737
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.8 895.296a47.36 47.36 0 0 1-47.488-46.976c0-73.472 60.16-132.928 134.592-132.928h630.144a47.36 47.36 0 0 1 47.552 46.912 46.4 46.4 0 0 1-47.488 46.912H219.904a40 40 0 0 0-39.552 39.104 47.36 47.36 0 0 1-47.552 46.976z",
    fill: "#000000",
    "p-id": 43738
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.24d06fa0e1094d2f736725cc7e4f2d1a.svg";
export { ForwardRef as ReactComponent };